<template>
  <div style="    display: inline-block;">
    <el-upload v-if="uploadurl.uploadingurl.length" :action="uploadurl.uploadingurl" :headers="headers"
      accept=".xlsx, .xls" multiple :on-success="upLoadSuccess">
      <el-button size="small" type="success">点击上传</el-button>
    </el-upload>
    <el-button v-if="uploadurl.downloadurl.length" size="small" type="primary" @click="downloadexcel" :loading="downloadLoading">导出excel</el-button>

  </div>
</template>
<script>

import axios from "axios";
import { getToken } from "@/utils/auth";
import { Encrypt, Decrypt } from '@/utils/index.js'
import { SHA256 } from 'crypto-js'
export default {
  name: "UploadImg",
  components: {
  },
  props: {
    search: {
      type: Function,
      default: null,
    },
    searchform: {
      type: Object,
      default: {},
    },
    uploadurl: {
      type: Object,
      default: '',
    },
  },
  data() {
    return {
      fileList: [],
      cropperImg: "", // 需要裁剪的图片
      showCropper: false, // 是否显示裁剪框
      downloadLoading: false,
      uploadFile: "", // 裁剪后的文件
      headers: {},
    };
  },
  mounted() {
    let time = Date.now();
    this.headers['signature'] = SHA256('timestamp' + time + process.env.VUE_APP_BASE_signature).toString();
    this.headers['timestamp'] = time;
    let obj = { token: Decrypt(getToken()), timestamp: time };
    // this.headers['Token'] = Encrypt(JSON.stringify(obj));
  },
  methods: {
    getdateyymmdd() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1; // 月份从0开始，需要加1
      const day = currentDate.getDate();
      let date = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
      return date;
    },
    // 导出通用方法
    downloadexcel() {
      this.downloadLoading = true;
      let that = this;
      axios({
        url: this.uploadurl.downloadurl,
        method: "post",
        data: this.searchform,
        timeout: 200000,
        headers: this.headers,
        responseType: "blob" // 设置响应类型为arraybuffer
      })
        .then(function (response) {
          console.log(response.headers['content-type'], response, '导出返回数据')
          if (response.headers['content-type'] !== 'application/json') {
            const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `${that.$route.meta.title + that.getdateyymmdd()}.xls`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            that.blobToJson(response.data).then(result => {
              // 在这里处理 Promise 返回的结果
              console.log(result); // 打印 Promise 对象中的值
              that.$message({
                type: "warning",
                message: result.message
              });
            })

          }
          that.downloadLoading = false;
        })
        .catch(function (error) {
          console.log(error);
        });

    },
    upLoadSuccess(val) {
      console.log(val)
      if (val.status_code == 200) {
        this.$message({
          type: "success",
          message: "上传成功!"
        });
      } else {
        this.$message({
          type: "success",
          message: val.message
        });
      }
    },



    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
          resolve(e.target.result);
        };
        // readAsDataURL
        fileReader.readAsDataURL(blob);
        fileReader.onerror = () => {
          reject(new Error("blobToBase64 error"));
        };
      });
    },
    //
    dataURLtoFile: function (dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    blobToFile: function (theBlob, fileName) {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },



  },
};
</script>

<style lang="scss" scoped>
.UploadImg {
  .video-image {
    display: flex;

    figure {
      width: 100px;

      img {
        width: 100%;
        display: block;
      }
    }
  }
}
</style>
